export default __webpack_public_path__ + "static/media/coffeeHeader.df71bebf.png";